var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIraq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30 24H0v-8h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bd2a2b",
    d: "M30 8H0V0h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3c",
    d: "M8.95 13.04v-1.11l-.7.55.14.06v.5h-.92s-.28-.1-.35-.22c-.08-.1-.15-.49-.15-.49l-.7.45s.5.48.5 1.08S6 15 6 15a1.1 1.1 0 0 0 1.3-.85h7.36v-2.08l-.82-.57c-.71 0-.83.77-.83.77h-2.62l2.52-2.56-.42-.45-2.78 2.79v.77h3.96v-.5c0-.21.33-.23.33.06v.67z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3c",
    d: "m16.22 13.04.15-.2.37 1.3H15.1V9.28l.87.48s-.2.15-.19.18v3.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3c",
    d: "M21.25 13.04v-2.99l.54-.55v4.64h-3.62v-1.1c0-.5.58-.91 1.1-.64v-.41l-.12-.05.12-.11.55-.56v1.77h.44v-2.1l.55-.56v2.66zm-2.33 0h.35v-.13c-.02-.08-.07-.17-.24-.17-.3 0-.33.3-.1.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3c",
    d: "M20.03 9.5q.09-.02.1-.25-.01-.23-.1-.25-.1.02-.1.25t.1.25"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3c",
    d: "M19.67 10.03c-.3.05-.46-.1-.46-.1s.22.3.5.29c.27-.02.42-.24.42-.24s.12.2.4.15c.29-.04.28-.53.28-.53s-.18.3-.37.35c-.2.04-.37-.24-.37-.24s-.1.28-.4.32"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3c",
    d: "m23.39 13.04.23-.23.38 1.33h-1.66V9.28l.9.51-.24.1v3.15z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3c",
    d: "M8.48 14.8a.24.24 0 0 0-.06-.26.24.24 0 0 0-.33 0 .24.24 0 0 0 .16.41.24.24 0 0 0 .23-.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIraq);
export default __webpack_public_path__ + "static/media/iraq.ea9538d7249d2c0648221ddcfbea52f0.svg";
export { ForwardRef as ReactComponent };